import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import GochiMenuDetailTable from '../../components/molecules/GochiMenuDetailTable';
import CloseButton from '../../components/atoms/CloseButton';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, detail, updateOpenDetailModal }) => {
  const closeAction = () => updateOpenDetailModal(false);
  return (
    <div className={classes.root}>
      <Typography variant="h6">グループメニュー情報詳細</Typography>
      <div>
        <GochiMenuDetailTable
          menuName={detail.menuName}
          price={detail.price}
          taxTypeStr={detail.taxTypeStr}
          reducedTaxTypeStr={detail.reducedTaxTypeStr}
          description={detail.description}
          tags={detail.tags}
          image={detail.image}
          createdAt={detail.createdAt}
          updatedAt={detail.updatedAt}
        />
      </div>
      <div>
        <CloseButton onClickAction={closeAction} />
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
